import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { Observable } from "rxjs";
import { distinctUntilChanged, filter, map, startWith } from "rxjs/operators";
import { IBreadcrumb } from "../../shared/interfaces/breadcrumb.type";
import { ThemeConstantService } from '../../shared/services/theme-constant.service';
import { AuthGuardService } from 'src/app/shared/services/AuthGuardService';
import { AngularFireDatabase } from '@angular/fire/database';
import { StoreItem } from 'src/app/shared/main-datasource';

@Component({
  selector: 'app-common-layout',
  templateUrl: './common-layout.component.html',
})

export class CommonLayoutComponent  {

  showAlert: boolean = false
  breadcrumbs$: Observable<IBreadcrumb[]>;
  contentHeaderDisplay: string;
  isFolded : boolean ;
  isSideNavDark : boolean;
  isExpand: boolean;
  selectedHeaderColor: string;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private db: AngularFireDatabase,
    private themeService: ThemeConstantService, private authService: AuthGuardService)
  {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        let child = this.activatedRoute.firstChild;
        while (child) {
          if (child.firstChild) {
            child = child.firstChild;
          } else if (child.snapshot.data && child.snapshot.data['headerDisplay']) {
            return child.snapshot.data['headerDisplay'];
          } else {
            return null;
          }
        }
        return null;
      })
    ).subscribe( (data: any) => {
      this.contentHeaderDisplay = data;
    });
  }

  ngOnInit() {

    if(this.authService.mUser.role.store)
    {
      let ref = this.db.list<StoreItem>('stores', ref => {
        return ref.orderByKey().equalTo(this.authService.mUser.storeId);
      });

      ref.snapshotChanges().subscribe(d=>{

        if (d.length > 0)
        {
          const data   = d[0];
          let store =  <StoreItem> data.payload.val();
          if(store.membership != "premium"){
              this.showAlert = true
          }
        }
      })
    }

    this.breadcrumbs$ = this.router.events.pipe(
      startWith(new NavigationEnd(0, '/', '/')),
      filter(event => event instanceof NavigationEnd),distinctUntilChanged(),
      map(data =>
        this.buildBreadCrumb(this.activatedRoute.root)
      )
    );

    this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
    this.themeService.isSideNavDarkChanges.subscribe(isDark => this.isSideNavDark = isDark);
    this.themeService.selectedHeaderColor.subscribe(color => this.selectedHeaderColor = color);
    this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);
  }

  private buildBreadCrumb(route: ActivatedRoute, url: string = '', breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {

    let label = '', path = '/', display = null;
    if (route.routeConfig) {
      if (route.routeConfig.data) {
        label = route.routeConfig.data['title'];
        path += route.routeConfig.path;
      }
    } else {
      label = '';
      path += 'home';
    }

    const nextUrl = path && path !== '/home' ? `${url}${path}` : url;
    const breadcrumb = <IBreadcrumb>{
      label: label, url: "/" + nextUrl
    };

    var newBreadcrumbs = label ? [...breadcrumbs, breadcrumb] : [...breadcrumbs];
    if (route.firstChild) {
      return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
    }

    if(newBreadcrumbs.length > 1)
    {
      //newBreadcrumbs = newBreadcrumbs.splice(newBreadcrumbs.length - 1,1)
      return newBreadcrumbs;
    }
    else
      return newBreadcrumbs;
  }

  upgradePricing(){

  }
}
